export type UserRoleType =
  | 'LOOKER_ADMIN'
  | 'SUPER_ADMIN'
  | 'OPEN_ADMIN'
  | 'AGENCY_ADMIN'
  | 'BUSINESS_ADMIN'
  | 'BUSINESS_CASHIER'
  | 'MERCHANT_NETWORK_ADMIN'
  | 'BENEFICIARY'
  | 'SUPPORT_ADMIN'
  | 'SUPPORT'
  | 'TRANSACTION_MANAGER'
  | 'PAYMENT_ADMIN'
  | 'PRUNEO_ADMIN'
  | 'VISITOR'

export type { App } from '@open/contracts';
import type { App } from '@open/contracts';
export type AuthType = 'BENEFICIARY' | 'ADMIN' | 'NONE';

export const userRolesByApp: Record<App, UserRoleType[]> = {
  admin: ['LOOKER_ADMIN', 'SUPER_ADMIN', 'OPEN_ADMIN', 'SUPPORT', 'TRANSACTION_MANAGER', 'SUPPORT_ADMIN', 'PAYMENT_ADMIN', 'PRUNEO_ADMIN'],
  webemployeur: ['AGENCY_ADMIN'],
  mobile: ['BENEFICIARY'],
  mobileCashier: ['BUSINESS_CASHIER', 'BUSINESS_ADMIN'],
  mobileBenef: ['BENEFICIARY'],
  webBusiness: ['BUSINESS_ADMIN', 'MERCHANT_NETWORK_ADMIN'],
};

export const availableRoles: UserRoleType[] = [
  'LOOKER_ADMIN',
  'SUPER_ADMIN',
  'OPEN_ADMIN',
  'AGENCY_ADMIN',
  'BENEFICIARY',
  'BUSINESS_ADMIN',
  'BUSINESS_CASHIER',
  'MERCHANT_NETWORK_ADMIN',
  'TRANSACTION_MANAGER',
  'SUPPORT_ADMIN',
  'SUPPORT',
  'PAYMENT_ADMIN',
  'PRUNEO_ADMIN',
  'VISITOR',
];